"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleTemplateVisibility = void 0;
var RuleTemplateVisibility;
(function (RuleTemplateVisibility) {
    /** "My rules" — only the author. */
    RuleTemplateVisibility["PRIVATE"] = "PRIVATE";
    /** "Shared rules" — everyone in the workspace. */
    RuleTemplateVisibility["SHARED"] = "SHARED";
})(RuleTemplateVisibility = exports.RuleTemplateVisibility || (exports.RuleTemplateVisibility = {}));
